import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { Holiday } from '../calendar/holiday';

export class CalendarBuilder {

  static buildHolidayFromJson(json) {
    return (json)
      ? new Holiday(
        json.hash,
        parseNumber(json.date)
      )
      : null;
  }

  static buildHolidaysFromList(list) {
    return mapCollection(CalendarBuilder.buildHolidayFromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/calendar.builder.ts